// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"643154c5","161":"1f6130ba","256":"60b4859f","258":"a06f3db0","261":"6270bfd9","568":"b4958b05","610":"61333494","809":"8dec61c3","825":"11c9a268","886":"f4836b6d","895":"2752fb2a"}[chunkId] + ".chunk.js";
};